import React from "react";
import PrivateRouting from "../PrivateRouting";

const Routing = () => {
  return <PrivateRouting />;
};

export default Routing;
